/**
 * Obtiene la clase CSS para el badge de estado de postulación
 * @param {number} statusId - ID del estado
 * @returns {string} - Clase CSS para el badge
 */
export function getStatusBadgeClass(statusId) {
  switch (statusId) {
    case 1:
      return "badge-pending"; // Pendiente/Borrador
    case 3:
      return "badge-approved"; // Aprobado (Basado en lógica del controlador)
    case 2:
      return "badge-rejected"; // Rechazado
    case 4:
      return "badge-info"; // En revisión
    default:
      return "badge-secondary";
  }
}

/**
 * Obtiene la clase CSS para el badge de estado de pago
 * @param {number} statusId - ID del estado de pago
 * @returns {string} - Clase CSS para el badge
 */
export function getPaymentStatusBadgeClass(statusId) {
  switch (statusId) {
    case 1:
      return "payment-tag-pending"; // Pago Pendiente
    case 3:
      return "payment-tag-paid"; // Pagado
    case 2:
      return "payment-tag-rejected"; // Rechazado
    case 4:
      return "payment-tag-process"; // En proceso (O incompleto)
    default:
      return "payment-tag-pending";
  }
}

/**
 * Deshabilita fechas futuras
 * @param {Date} date - Fecha a verificar
 * @returns {boolean} - True si la fecha es futura
 */
export function disableFutureDates(date) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return date > today;
}
